var map = {
	"./Academic/Academic": 7695,
	"./Academic/Academic.vue": 7695,
	"./Academic/Course/Add": 9544,
	"./Academic/Course/Add.vue": 9544,
	"./Academic/Course/Edit": 2918,
	"./Academic/Course/Edit.vue": 2918,
	"./Academic/Course/List": 8775,
	"./Academic/Course/List.vue": 8775,
	"./Academic/CourseSemester/Add": 6981,
	"./Academic/CourseSemester/Add.vue": 6981,
	"./Academic/CourseSemester/Edit": 8827,
	"./Academic/CourseSemester/Edit.vue": 8827,
	"./Academic/CourseSemester/List": 8256,
	"./Academic/CourseSemester/List.vue": 8256,
	"./Academic/CourseType/Add": 6030,
	"./Academic/CourseType/Add.vue": 6030,
	"./Academic/CourseType/Edit": 8901,
	"./Academic/CourseType/Edit.vue": 8901,
	"./Academic/CourseType/List": 7326,
	"./Academic/CourseType/List.vue": 7326,
	"./Academic/CourseYear/Add": 3365,
	"./Academic/CourseYear/Add.vue": 3365,
	"./Academic/CourseYear/Edit": 6469,
	"./Academic/CourseYear/Edit.vue": 6469,
	"./Academic/CourseYear/List": 4058,
	"./Academic/CourseYear/List.vue": 4058,
	"./Academic/CourseYearBatch/Add": 417,
	"./Academic/CourseYearBatch/Add.vue": 417,
	"./Academic/CourseYearBatch/Edit": 2071,
	"./Academic/CourseYearBatch/Edit.vue": 2071,
	"./Academic/CourseYearBatch/List": 4519,
	"./Academic/CourseYearBatch/List.vue": 4519,
	"./Academic/Duration/Add": 8242,
	"./Academic/Duration/Add.vue": 8242,
	"./Academic/Duration/Edit": 1210,
	"./Academic/Duration/Edit.vue": 1210,
	"./Academic/Duration/List": 3366,
	"./Academic/Duration/List.vue": 3366,
	"./Academic/DurationSemester/Edit": 5099,
	"./Academic/DurationSemester/Edit.vue": 5099,
	"./Academic/DurationSemester/List": 516,
	"./Academic/DurationSemester/List.vue": 516,
	"./Academic/Semester/Add": 6156,
	"./Academic/Semester/Add.vue": 6156,
	"./Academic/Semester/Edit": 6910,
	"./Academic/Semester/Edit.vue": 6910,
	"./Academic/Semester/List": 8310,
	"./Academic/Semester/List.vue": 8310,
	"./Academic/Subject/Add": 3449,
	"./Academic/Subject/Add.vue": 3449,
	"./Academic/Subject/Edit": 5967,
	"./Academic/Subject/Edit.vue": 5967,
	"./Academic/Subject/List": 2350,
	"./Academic/Subject/List.vue": 2350,
	"./Academic/Topic/Add": 7497,
	"./Academic/Topic/Add.vue": 7497,
	"./Academic/Topic/Edit": 3713,
	"./Academic/Topic/Edit.vue": 3713,
	"./Academic/Topic/List": 56,
	"./Academic/Topic/List.vue": 56,
	"./Academic/TopicNotes": 1967,
	"./Academic/TopicNotes.vue": 1967,
	"./Administrative/Administrative": 7150,
	"./Administrative/Administrative.vue": 7150,
	"./Administrative/Branch/Add": 3999,
	"./Administrative/Branch/Add.vue": 3999,
	"./Administrative/Branch/Edit": 419,
	"./Administrative/Branch/Edit.vue": 419,
	"./Administrative/Branch/List": 7077,
	"./Administrative/Branch/List.vue": 7077,
	"./Administrative/Branch/Staff": 8854,
	"./Administrative/Branch/Staff.vue": 8854,
	"./Administrative/Branch/Teacher": 3300,
	"./Administrative/Branch/Teacher.vue": 3300,
	"./Administrative/Branch/User": 8020,
	"./Administrative/Branch/User.vue": 8020,
	"./Administrative/Faculty/Add": 1466,
	"./Administrative/Faculty/Add.vue": 1466,
	"./Administrative/Faculty/AddSalary": 6552,
	"./Administrative/Faculty/AddSalary.vue": 6552,
	"./Administrative/Faculty/Edit": 5198,
	"./Administrative/Faculty/Edit.vue": 5198,
	"./Administrative/Faculty/EditSalary": 875,
	"./Administrative/Faculty/EditSalary.vue": 875,
	"./Administrative/Faculty/List": 8819,
	"./Administrative/Faculty/List.vue": 8819,
	"./Administrative/Faculty/View": 3318,
	"./Administrative/Faculty/View.vue": 3318,
	"./Administrative/Staff/Create": 2489,
	"./Administrative/Staff/Create.vue": 2489,
	"./Administrative/Staff/List": 4576,
	"./Administrative/Staff/List.vue": 4576,
	"./Administrative/User/Edit": 1976,
	"./Administrative/User/Edit.vue": 1976,
	"./Administrative/User/List": 2931,
	"./Administrative/User/List.vue": 2931,
	"./Auth/ConfirmPassword": 4904,
	"./Auth/ConfirmPassword.vue": 4904,
	"./Auth/ForgotPassword": 4657,
	"./Auth/ForgotPassword.vue": 4657,
	"./Auth/Login": 5995,
	"./Auth/Login.vue": 5995,
	"./Auth/Register": 2092,
	"./Auth/Register.vue": 2092,
	"./Auth/ResetPassword": 5918,
	"./Auth/ResetPassword.vue": 5918,
	"./Auth/VerifyEmail": 2695,
	"./Auth/VerifyEmail.vue": 2695,
	"./Dashboard": 4286,
	"./Dashboard.vue": 4286,
	"./Heads/Application/Add": 8355,
	"./Heads/Application/Add.vue": 8355,
	"./Heads/Application/Edit": 4764,
	"./Heads/Application/Edit.vue": 4764,
	"./Heads/Application/List": 4536,
	"./Heads/Application/List.vue": 4536,
	"./Heads/Contact/Add": 8793,
	"./Heads/Contact/Add.vue": 8793,
	"./Heads/Contact/Edit": 9323,
	"./Heads/Contact/Edit.vue": 9323,
	"./Heads/Contact/List": 9863,
	"./Heads/Contact/List.vue": 9863,
	"./Heads/Department/Edit": 9612,
	"./Heads/Department/Edit.vue": 9612,
	"./Heads/Department/List": 1075,
	"./Heads/Department/List.vue": 1075,
	"./Heads/Designation/Edit": 9599,
	"./Heads/Designation/Edit.vue": 9599,
	"./Heads/Designation/List": 4760,
	"./Heads/Designation/List.vue": 4760,
	"./Heads/ExpenseType/Edit": 9477,
	"./Heads/ExpenseType/Edit.vue": 9477,
	"./Heads/ExpenseType/List": 8914,
	"./Heads/ExpenseType/List.vue": 8914,
	"./Heads/FeesType/Edit": 2185,
	"./Heads/FeesType/Edit.vue": 2185,
	"./Heads/FeesType/List": 665,
	"./Heads/FeesType/List.vue": 665,
	"./Heads/Heads": 3785,
	"./Heads/Heads.vue": 3785,
	"./Heads/Holiday/List": 5509,
	"./Heads/Holiday/List.vue": 5509,
	"./Heads/PaymentMode/Edit": 795,
	"./Heads/PaymentMode/Edit.vue": 795,
	"./Heads/PaymentMode/List": 5927,
	"./Heads/PaymentMode/List.vue": 5927,
	"./Heads/Role/Edit": 1245,
	"./Heads/Role/Edit.vue": 1245,
	"./Heads/Role/List": 2287,
	"./Heads/Role/List.vue": 2287,
	"./Heads/SalaryHead/Edit": 1492,
	"./Heads/SalaryHead/Edit.vue": 1492,
	"./Heads/SalaryHead/List": 9019,
	"./Heads/SalaryHead/List.vue": 9019,
	"./IdCard": 2075,
	"./IdCard.vue": 2075,
	"./Internal/Admission/Attendance": 2164,
	"./Internal/Admission/Attendance.vue": 2164,
	"./Internal/Admission/EmiStructure": 8453,
	"./Internal/Admission/EmiStructure.vue": 8453,
	"./Internal/Admission/Fee/Create": 3207,
	"./Internal/Admission/Fee/Create.vue": 3207,
	"./Internal/Admission/Fee/EmiStructure": 9369,
	"./Internal/Admission/Fee/EmiStructure.vue": 9369,
	"./Internal/Admission/List": 2932,
	"./Internal/Admission/List.vue": 2932,
	"./Internal/Admission/Performance/Index": 3150,
	"./Internal/Admission/Performance/Index.vue": 3150,
	"./Internal/Admission/Performance/Review": 5488,
	"./Internal/Admission/Performance/Review.vue": 5488,
	"./Internal/Admission/Performance/TeacherIndex": 4170,
	"./Internal/Admission/Performance/TeacherIndex.vue": 4170,
	"./Internal/Admission/Performance/TeacherReview": 5960,
	"./Internal/Admission/Performance/TeacherReview.vue": 5960,
	"./Internal/Admission/Performance/TeacherReviewTopics": 1445,
	"./Internal/Admission/Performance/TeacherReviewTopics.vue": 1445,
	"./Internal/Admission/Performance/TeacherVivia": 8791,
	"./Internal/Admission/Performance/TeacherVivia.vue": 8791,
	"./Internal/Admission/Performance/Viva": 5105,
	"./Internal/Admission/Performance/Viva.vue": 5105,
	"./Internal/Admission/PerformanceStatus": 5362,
	"./Internal/Admission/PerformanceStatus.vue": 5362,
	"./Internal/Admission/UniversityFeesStatusForm": 9630,
	"./Internal/Admission/UniversityFeesStatusForm.vue": 9630,
	"./Internal/Admission/View": 2500,
	"./Internal/Admission/View.vue": 2500,
	"./Internal/BlukIds/Index": 4010,
	"./Internal/BlukIds/Index.vue": 4010,
	"./Internal/BranchCourse/Edit": 8794,
	"./Internal/BranchCourse/Edit.vue": 8794,
	"./Internal/BranchCourse/List": 9153,
	"./Internal/BranchCourse/List.vue": 9153,
	"./Internal/BranchCourse/Result/Create": 1080,
	"./Internal/BranchCourse/Result/Create.vue": 1080,
	"./Internal/BranchCourse/Result/List": 1097,
	"./Internal/BranchCourse/Result/List.vue": 1097,
	"./Internal/Certificate/Index": 6444,
	"./Internal/Certificate/Index.vue": 6444,
	"./Internal/Collection/Create": 6934,
	"./Internal/Collection/Create.vue": 6934,
	"./Internal/Collection/List": 5067,
	"./Internal/Collection/List.vue": 5067,
	"./Internal/CourseFee/Add": 2523,
	"./Internal/CourseFee/Add.vue": 2523,
	"./Internal/CourseFee/Edit": 441,
	"./Internal/CourseFee/Edit.vue": 441,
	"./Internal/CourseFee/List": 3905,
	"./Internal/CourseFee/List.vue": 3905,
	"./Internal/Enquiry/Edit": 2070,
	"./Internal/Enquiry/Edit.vue": 2070,
	"./Internal/Enquiry/List": 1043,
	"./Internal/Enquiry/List.vue": 1043,
	"./Internal/Expense/Add": 3550,
	"./Internal/Expense/Add.vue": 3550,
	"./Internal/Expense/Edit": 2109,
	"./Internal/Expense/Edit.vue": 2109,
	"./Internal/Expense/List": 7975,
	"./Internal/Expense/List.vue": 7975,
	"./Internal/Holiday/Edit": 9758,
	"./Internal/Holiday/Edit.vue": 9758,
	"./Internal/Holiday/List": 1211,
	"./Internal/Holiday/List.vue": 1211,
	"./Internal/IdCardRegenerate/Index": 8374,
	"./Internal/IdCardRegenerate/Index.vue": 8374,
	"./Internal/Internal": 968,
	"./Internal/Internal.vue": 968,
	"./Internal/KTStudents/List": 6486,
	"./Internal/KTStudents/List.vue": 6486,
	"./Internal/Lead/Edit": 5905,
	"./Internal/Lead/Edit.vue": 5905,
	"./Internal/Lead/List": 7672,
	"./Internal/Lead/List.vue": 7672,
	"./Internal/Resource/List": 9002,
	"./Internal/Resource/List.vue": 9002,
	"./Internal/ResultAndCertificate/Create": 8149,
	"./Internal/ResultAndCertificate/Create.vue": 8149,
	"./Internal/ResultAndCertificate/Index": 9722,
	"./Internal/ResultAndCertificate/Index.vue": 9722,
	"./Internal/Schedule": 1457,
	"./Internal/Schedule.vue": 1457,
	"./Internal/Setting/Index": 5339,
	"./Internal/Setting/Index.vue": 5339,
	"./Internal/UniversityMarking/Entry": 1501,
	"./Internal/UniversityMarking/Entry.vue": 1501,
	"./Internal/UniversityMarking/List": 6302,
	"./Internal/UniversityMarking/List.vue": 6302,
	"./Internal/WeekSchedule/Add": 6029,
	"./Internal/WeekSchedule/Add.vue": 6029,
	"./Internal/WeekSchedule/Attendance": 8296,
	"./Internal/WeekSchedule/Attendance.vue": 8296,
	"./Internal/WeekSchedule/Edit": 2212,
	"./Internal/WeekSchedule/Edit.vue": 2212,
	"./Internal/WeekSchedule/List": 7087,
	"./Internal/WeekSchedule/List.vue": 7087,
	"./Internal/Workshop/Add": 3385,
	"./Internal/Workshop/Add.vue": 3385,
	"./Internal/Workshop/Edit": 6368,
	"./Internal/Workshop/Edit.vue": 6368,
	"./Internal/Workshop/List": 4992,
	"./Internal/Workshop/List.vue": 4992,
	"./Internal/Workshop/Students": 2859,
	"./Internal/Workshop/Students.vue": 2859,
	"./Notice/Add": 8389,
	"./Notice/Add.vue": 8389,
	"./Notice/BranchList": 6694,
	"./Notice/BranchList.vue": 6694,
	"./Notice/Edit": 4195,
	"./Notice/Edit.vue": 4195,
	"./Notice/Notice": 8172,
	"./Notice/Notice.vue": 8172,
	"./Notice/StudentList": 8251,
	"./Notice/StudentList.vue": 8251,
	"./Notice/TeacherList": 9969,
	"./Notice/TeacherList.vue": 9969,
	"./Others/Others": 6907,
	"./Others/Others.vue": 6907,
	"./Others/Resource/Add": 4163,
	"./Others/Resource/Add.vue": 4163,
	"./Others/Resource/Edit": 951,
	"./Others/Resource/Edit.vue": 951,
	"./Others/Resource/List": 4582,
	"./Others/Resource/List.vue": 4582,
	"./Others/Resource/View": 5109,
	"./Others/Resource/View.vue": 5109,
	"./Others/UniversityMarking/Add": 6758,
	"./Others/UniversityMarking/Add.vue": 6758,
	"./Others/UniversityMarking/Edit": 1516,
	"./Others/UniversityMarking/Edit.vue": 1516,
	"./Others/UniversityMarking/List": 6838,
	"./Others/UniversityMarking/List.vue": 6838,
	"./Others/UniversityMarking/Marks": 9469,
	"./Others/UniversityMarking/Marks.vue": 9469,
	"./Placement/Company/Add": 932,
	"./Placement/Company/Add.vue": 932,
	"./Placement/Company/Edit": 2513,
	"./Placement/Company/Edit.vue": 2513,
	"./Placement/Company/List": 7549,
	"./Placement/Company/List.vue": 7549,
	"./Placement/CompanyJob/Add": 7146,
	"./Placement/CompanyJob/Add.vue": 7146,
	"./Placement/CompanyJob/Edit": 4462,
	"./Placement/CompanyJob/Edit.vue": 4462,
	"./Placement/CompanyJob/List": 2323,
	"./Placement/CompanyJob/List.vue": 2323,
	"./Placement/CompanyJob/Students": 7138,
	"./Placement/CompanyJob/Students.vue": 7138,
	"./Placement/Placement": 25,
	"./Placement/Placement.vue": 25,
	"./Profile": 184,
	"./Profile.vue": 184,
	"./Report/List": 333,
	"./Report/List.vue": 333,
	"./Report/ReportNavbar": 1794,
	"./Report/ReportNavbar.vue": 1794,
	"./StudentExperienceLetter/Index": 3894,
	"./StudentExperienceLetter/Index.vue": 3894,
	"./Term/Add": 3916,
	"./Term/Add.vue": 3916,
	"./Term/Edit": 8394,
	"./Term/Edit.vue": 8394,
	"./Term/Index": 1990,
	"./Term/Index.vue": 1990,
	"./Welcome": 3045,
	"./Welcome.vue": 3045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;